module.exports = __webpack_public_path__ + "media/images/flags/1x1/esp-c93509a4ba9096e63a36e544a52566a6.svg";